import { useContext, useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import "./off-canvas.sass";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { ReportingContext } from "../../pages/home/home";
import { getReportingLinks } from "../../pages/reporting/links";
import { sendCallToAPI } from "../../common/generic_functions";
import { useStore } from "../../hooks-store/store";
import { LOCALSTORAGEKEYS } from "../../common/constants";



export const CheckWorkSpace = () => {

    const [store, dispatch] = useStore();
     const navigate = useNavigate();

    const loadData = async () => {
    const link = `${getReportingLinks("getAllWS")}`;
    let ws_results = await sendCallToAPI(link, store.accessToken);
    if (ws_results?.detail === "Invalid token.") {
      dispatch("CLEAR_DATA");
      navigate("/login");
    }
    if (!ws_results || !Array.isArray(ws_results)) {
      ws_results = [];
    }
    navigate("/" + ws_results[0]?.id);
  };

  loadData()
} 



export const SideNavButton = () => {
  const [show, setShow] = useState(false);
  const [store, dispatch] = useStore();
  const [workspaces, setWorkspaces] = useState([]);
  const current_workspace = localStorage.getItem(LOCALSTORAGEKEYS.CURRENT_WORKSPACE);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const loadData = async () => {
    const link = `${getReportingLinks("getAllWS")}`;
    let ws_results = await sendCallToAPI(link, store.accessToken);
    if (ws_results?.detail === "Invalid token.") {
      dispatch("CLEAR_DATA");
      navigate("/login");
    }
    if (!ws_results || !Array.isArray(ws_results)) {
      ws_results = [];
    }
     if (!current_workspace && !pathname.includes(current_workspace) && ws_results[0]?.id) {
        navigate("/" + ws_results[0]?.id)
        localStorage.setItem(LOCALSTORAGEKEYS.CURRENT_WORKSPACE, ws_results[0]?.id)
        localStorage.setItem(LOCALSTORAGEKEYS.CURRENT_WORKSPACE_NAME, ws_results[0]?.name)
    }

    setWorkspaces(ws_results);
  };
  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div >
      <BurgerMenuIcon isActive={show} setIsActive={() => setShow(!show)} />
      <Offcanvas show={show} onHide={() => setShow(false)} placement="start">
        <Offcanvas.Header className="p-2 off-canvas-header">
          <Offcanvas.Title style={{ width: "100%" }}>
            <div className="d-flex align-items-end w-100 mb-3 lh-1 ms-3">
          <h5 className="">
                <CurrentWorkSpace />
              </h5>
            </div>
          </Offcanvas.Title>
          <div style={{ display: "flex", width: "10%", flexDirection: "row-reverse" }}>
            <BurgerMenuIcon isActive={show} setIsActive={() => setShow(!show)} />
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <WorkspaceSearch toogleActive={() => setShow(!show)} workspaces={workspaces} />
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

const createRhichMarkedSearch = (items, value) => {
  const result = [];
  const val = value.toLowerCase();
  for (let i = 0; i < items.length; i++) {
    const element = items[i]["name"];
    const indexOf = element.toLowerCase().indexOf(val);
    if (indexOf !== -1) {
      let temp = [element.substring(0, indexOf)];
      temp.push(
        <span key={element + i} className="marked-text">
          {element.substring(indexOf, val.length + indexOf) + ""}
        </span>
      );
      temp.push(element.substring(val.length + indexOf, element.length));
      result.push(temp);
    }
  }
  return result;
};

const WorkspaceSearch = ({ workspaces, toogleActive }) => {
  const [value, setValue] = useState("");
  // const filteredSpaces = value && value !== "" ? createRhichMarkedSearch(workspaces, value) : workspaces;
  const filteredSpaces = value && value !== "" ? workspaces.filter((x) => x["name"].toLowerCase().includes(value.toLowerCase())) : workspaces;
  return (
    <div>
      <input value={value}
      style={{
          border: "1px solid #abababff",
          borderRadius: "8px",
          padding: "5px",
          fontSize: "16px",
          backgroundColor: "white",
          color: "#333",
          outline: "none",
        }} 
      placeholder="🔍Filter Workspaces" onChange={(e) => setValue(e.target.value)} />
      <div>
        <ul>
          {filteredSpaces?.map((x, idx) => (
            <li key={idx + x}>
              <Link to={`/${x.id}`} onClick={() => toogleActive()}>
                <b style={{color: "#807f7e"}}>{x.name}</b>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

const BurgerMenuIcon = ({ isActive, setIsActive }) => {
  const toggleIcon = () => {
    setIsActive(!isActive);
  };

  return (
    <button className="burger-menu-icon" onClick={toggleIcon}>
      <div className={`line first-line ${isActive ? "x-top" : ""}`} />
      <div className={`line second-line ${isActive ? "hide" : ""}`} />
      <div className={`line third-line ${isActive ? "x-bottom" : ""}`} />
    </button>
  );
};

const CurrentWorkSpace = () => {
  const { getCurrentWorkSpaceName } = useContext(ReportingContext);
  return (
    <div>
      <div>Your current workspace</div>
      <div>{getCurrentWorkSpaceName() ?? ""}</div>
    </div>
  );
};
